import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _uniqueId from "lodash/uniqueId";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { memo } from 'react';
import { View, Text, Page, Image } from '@react-pdf/renderer';
import { Card } from '@mummssoftware/utils/constants';
import { PrintFooterPDFComponent } from '../Footer';
import { PrintHeaderPDFComponent } from '../Header';
import { fromDateToDate, ios, pageOrientation, pageSize, safari, styles } from '../../utils';
import defaults from '../../translations/en.json';
const NoCertificationsDataComponent = /*#__PURE__*/memo(({
  dashboardPrintConfig
}) => /*#__PURE__*/React.createElement(View, {
  style: [styles.width100, styles.textAlignCenter]
}, /*#__PURE__*/React.createElement(Text, {
  style: [styles.printerHeaderText]
}, defaults.certifications), dashboardPrintConfig !== null && dashboardPrintConfig !== void 0 && dashboardPrintConfig.fromDate && dashboardPrintConfig !== null && dashboardPrintConfig !== void 0 && dashboardPrintConfig.toDate ? /*#__PURE__*/React.createElement(Text, {
  style: [styles.fontFamilyItalic, styles.fontSizeTenPt, styles.marginYPointTwoCm]
}, fromDateToDate(dashboardPrintConfig)) : null, /*#__PURE__*/React.createElement(Text, {
  style: styles.CPFTableDetailsText
}, dashboardPrintConfig !== null && dashboardPrintConfig !== void 0 && dashboardPrintConfig.fromDate && dashboardPrintConfig !== null && dashboardPrintConfig !== void 0 && dashboardPrintConfig.toDate ? defaults.noCertificationsDateRange : defaults.noCertifications)));

var _ref = /*#__PURE__*/React.createElement(PrintFooterPDFComponent, null);

export const CertificationsPDF = ({
  pdfCertAppSnapshot,
  browser,
  patient,
  dashboardPrintConfig
}) => {
  const shallowDashboardPrintConfigView = dashboardPrintConfig && _objectSpread({}, dashboardPrintConfig);

  const CertificationsPrintConfig = shallowDashboardPrintConfigView === null || shallowDashboardPrintConfigView === void 0 ? void 0 : shallowDashboardPrintConfigView.DocLink;
  const showNoCertsPrintUI = !Array.isArray(pdfCertAppSnapshot) || pdfCertAppSnapshot && pdfCertAppSnapshot.length === 0;
  const CertificationsRadioChoice = CertificationsPrintConfig.view;
  return /*#__PURE__*/React.createElement(Page, {
    size: pageSize,
    orientation: pageOrientation,
    style: browser && browser.name === safari || browser && browser.name === ios ? styles.pageSafari : styles.page
  }, showNoCertsPrintUI ? /*#__PURE__*/React.createElement(NoCertificationsDataComponent, {
    dashboardPrintConfig: dashboardPrintConfig
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PrintHeaderPDFComponent, {
    browser: browser,
    patient: patient
  }), /*#__PURE__*/React.createElement(View, {
    style: [styles.textAlignCenter, styles.width100, styles.marginBottomPointFiveCm]
  }, /*#__PURE__*/React.createElement(Text, {
    style: [styles.printerHeaderText]
  }, defaults.certifications), dashboardPrintConfig && dashboardPrintConfig.fromDate && dashboardPrintConfig.toDate && /*#__PURE__*/React.createElement(Text, {
    style: [styles.fontFamilyItalic, styles.fontSizeTenPt, styles.marginYPointTwoCm]
  }, fromDateToDate(dashboardPrintConfig)), Array.isArray(pdfCertAppSnapshot) && pdfCertAppSnapshot.map((certImage, index) => {
    const uniqueId = _uniqueId('cert-reactpdf-');

    return index === 0 && /*#__PURE__*/React.createElement(Image, {
      key: uniqueId,
      style: CertificationsRadioChoice === Card ? [styles.firstCertCardStyles] : {},
      src: certImage
    });
  })), Array.isArray(pdfCertAppSnapshot) && pdfCertAppSnapshot && pdfCertAppSnapshot.length > 0 && pdfCertAppSnapshot.map((certImage, index) => {
    const uniqueId = _uniqueId('cert-reactpdf-');

    return index > 0 ? /*#__PURE__*/React.createElement(Image, {
      style: CertificationsRadioChoice === Card ? [styles.certCardStyles] : {},
      break: CertificationsRadioChoice === Card,
      src: certImage,
      key: uniqueId
    }) : null;
  })), _ref);
};